import getEmailCustomerUtil from 'utils/customer/get-email'

export default function hasEmailCustomerUtil () {
  return !!getEmailCustomerUtil()
}
